module.exports = __webpack_public_path__ + "img/yxlogo_black.5932ff61.png";